export default __webpack_public_path__ + "static/media/Tent_Move_2sm.85ce5378.gif";